import { Button } from '@/components/ui/button';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { Capacitor } from '@capacitor/core';
import { IonButton, IonIcon, IonPage, IonRouterLink, IonSpinner } from '@ionic/react';
import { logoApple, logoGoogle } from 'ionicons/icons';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

const Mobile: React.FC = () => {
  const { t } = useTranslation(['Auth', 'MGP']);
  const [error, setError] = useState('');
  const [isAppleLoading, setIsAppleLoading] = useState(false);
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  const history = useHistory();

  return (
    <IonPage>
      <main className="relative w-full overflow-hidden min-h-screen">
        {/* Video Background */}
        <div className="absolute inset-0 w-full h-screen-full" style={{ willChange: 'auto' }}>
          <video
            autoPlay
            loop
            muted
            playsInline
            className="absolute w-full h-full object-cover"
          >
            <source src="/assets/videos/banner.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="absolute inset-0 bg-black/70"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 flex flex-col items-center justify-between min-h-screen p-8">
          <div className="flex-1 flex flex-col mt-safe-offset-8 w-full max-w-md">
            <img src="/assets/images/logos/text-logo-green.svg" className="w-2/3 mx-auto" alt="CapGolf Logo" />
          </div>
          <div className="flex-1 flex flex-col mt-safe-offset-8 w-full max-w-md">
            {/* <div className="text-4xl font-bold justify-center flex flex-col text-white"><span>DISCOVER.</span><span>PROGRESS.</span><span>SHARE.</span></div> */}
          </div>

          <div className="w-full max-w-md space-y-4 mb-8">
            {Capacitor.isNativePlatform() ? (
              <>
                {Capacitor.getPlatform() === 'ios' ? (
                  <IonButton
                    color="dark"
                    className="w-full"
                    shape='round'
                    disabled={isAppleLoading}
                    onClick={async () => {
                      try {
                        setIsAppleLoading(true);
                        setError('');
                        const result = await FirebaseAuthentication.signInWithApple();
                        if (result) {
                          history.push('/dashboard')
                        }
                      } catch (err: any) {
                        console.error('Error:', err);
                        setError(err.message || t('Auth:sign_in_error'));
                      } finally {
                        setIsAppleLoading(false);
                      }
                    }}>
                    {isAppleLoading ? (
                      <IonSpinner name="dots" />
                    ) : (
                      <div className="flex items-center justify-center gap-2 w-full">
                        <IonIcon
                          icon={logoApple}
                          className="w-6 h-6 relative -top-0.5"
                          style={{ margin: 0 }}
                        />
                        <span>{t('Auth:sign_in_with_apple')}</span>
                      </div>
                    )}
                  </IonButton>
                ) : (
                  <IonButton
                    color="transparent" fill="clear" className='bg-white text-black rounded-full w-full'
                    disabled={isGoogleLoading}
                    onClick={async () => {
                      try {
                        setIsGoogleLoading(true);
                        setError('');
                        const result = await FirebaseAuthentication.signInWithGoogle();
                        if (result) {
                          history.push('/dashboard')
                        }
                      } catch (err: any) {
                        console.error('Error:', err);
                        setError(err.message || t('Auth:sign_in_error'));
                      } finally {
                        setIsGoogleLoading(false);
                      }
                    }}>
                    {isGoogleLoading ? (
                      <IonSpinner name="dots" />
                    ) : (
                      <div className="flex items-center justify-center gap-2 w-full">
                        <img src="/assets/images/social/google.svg" className="w-5 h-5" />
                        <span>{t('Auth:sign_in_with_google')}</span>
                      </div>
                    )}
                  </IonButton>
                )}

                <IonRouterLink routerLink="/sign-in" className="block text-center">
                  <IonButton color="transparent" fill="clear" className='bg-white text-black rounded-full' shape='round'>
                    {t('Auth:more_options')}
                  </IonButton>
                </IonRouterLink>
              </>
            ) : (
              <>
                <IonRouterLink routerLink="/sign-up" className="block w-full">
                  <Button className="w-full" size="lg">
                    {t('MGP:signup', 'Sign Up')}
                  </Button>
                </IonRouterLink>
                <IonRouterLink routerLink="/sign-in" className="block w-full">
                  <Button variant="outline" className="w-full bg-white/40">
                    {t('MGP:already_have_account', 'Already have an account?')}
                  </Button>
                </IonRouterLink>
              </>
            )}

          </div>
        </div >
      </main >
    </IonPage >
  );
};

export default Mobile;
